export const STATEMENT_ACTIONS = {
  JOIN_CLUB: 2,
  LEAVE_CLUB: 1,
  REQUEST_TRANSFER: 4,
  TRANSFER: 3,
};

export const STATEMENT_STATUSES = {
  ACCEPTED: 1,
  CANCELED: 2,
  DELETED: 4,
  DRAFT: 0,
  NEW: 7,
  REVIEWING: 3,
  REVIEWING_RFS: 6,
  SENT: 5,
};

export const STATEMENT_TYPES = {
  ALL: 'all',
  NEW: 'new',
};
